import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { config, REGISTERED_THROUGH } from "../../config";
import axiosApi from "../../core/interceptor/interceptor";

export default function InvitePlayer() {
	const details = {
		accepted: useParams().accepted,
		token: useParams().token,
	}
	const [data, setData] = useState([]);
	const [checkValidate, setCheckValidate] = useState(false);
	const history = useHistory();
	useEffect(() => {
		validateToken();
		//eslint-disable-next-line
	}, []);
	console.log(details);
	useEffect(() => {
		handleInvitation();
		//eslint-disable-next-line
	}, [data, checkValidate])

	const validateToken = () => {
		axiosApi.put(`${config.apiUrl}/misc/validate-token/${details.token}`)
			.then((res) => {
				setData(res.data.data);
				setCheckValidate(true);
			}, (err) => {
				history.push('/');
			})
	}

	const handleInvitation = () => {
		if (checkValidate) {
			if (details.accepted === 'true') {
				if (data.player_id) {
					axiosApi.post(`${config.apiUrl}/misc/add-player/${data.id}`, {
						team_id: data.team_id,
						user_id: data.player_id,
						email: data.email,
						policies: true,
						covid_policies: true,
						registered_through: REGISTERED_THROUGH,
					}).then((res) => {
						history.push({
							pathname: '/',
							state: {
								status: 'login',
								email: data?.email
							}
						});
					})
				} else if (data !== null) {
					axiosApi.put(`${config.apiUrl}/misc/invite-player/${data.id}`)
						.then((res) => {
							console.log(res);
						}, (err) => {
							history.push(`/?signup=true&invitePlayerId=${data.id}`,{
								status: 'signup',
								email: data?.email
							});
						})
				}
			} else {
				axiosApi.delete(`${config.apiUrl}/misc/delete-invitation/${data.id}`)
					.then(() => {
						history.push('/');
					}, (err) => {
						console.error(err);
					})
			}
		}
	}

	return <>
		<div>Please wait.....</div>
	</>
}